export default __webpack_public_path__ + "static/media/ETH-FIL.0bf108a1.png";